/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Err_Existing_MsgInputs */

const es_ab_err_existing_msg = /** @type {(inputs: Ab_Err_Existing_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta cuenta ya existe, por favor inicia sesión para añadir tu barco. Si no recuerdas tu contraseña, puedes recuperarla desde la página de inicio de sesión.`)
};

const gl_ab_err_existing_msg = /** @type {(inputs: Ab_Err_Existing_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta conta xa existe, inicia sesión para engadir o teu barco. Se non lembras o contrasinal, podes recuperalo desde a páxina de inicio de sesión.`)
};

const en_ab_err_existing_msg = /** @type {(inputs: Ab_Err_Existing_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This account already exists. Sign in to add your boat. If you forgot your password, recover it from the sign-in page.`)
};

/**
* | output |
* | --- |
* | "This account already exists. Sign in to add your boat. If you forgot your password, recover it from the sign-in page." |
*
* @param {Ab_Err_Existing_MsgInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_err_existing_msg = /** @type {((inputs?: Ab_Err_Existing_MsgInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Err_Existing_MsgInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_err_existing_msg(inputs)
	if (locale === "en") return en_ab_err_existing_msg(inputs)
	return es_ab_err_existing_msg(inputs)
});